(function () {
  var svg = document.querySelector('.usmap');
  var dataEl = document.getElementById('heat-data');
  if (!svg || !dataEl) return;
  var players = [];
  try { players = JSON.parse(dataEl.textContent).filter(Boolean); } catch (e) { return; }

  var labels = svg.querySelector('.hm-labels');

  function paint(filter) {
    // reset
    labels.innerHTML = '';
    svg.querySelectorAll('.hm-state').forEach(function (p) {
      p.classList.remove('hot1', 'hot2', 'hot3');
      var t = p.querySelector('title');
      if (t) t.textContent = p.dataset.st;
    });

    var states = {};
    players.forEach(function (pl) {
      var r = parseFloat(pl.r) || 0;
      var stars = Math.floor(r);
      if (filter !== 'all' && stars !== parseInt(filter, 10)) return;
      var st = (pl.st || '').trim().toUpperCase();
      if (!st) return;
      if (!states[st]) states[st] = { count: 0, max: 0, names: [] };
      states[st].count++;
      states[st].max = Math.max(states[st].max, r);
      states[st].names.push(pl.n);
    });

    Object.keys(states).forEach(function (st) {
      var path = svg.querySelector('.hm-state[data-st="' + st + '"]');
      if (!path) return;
      var d = states[st];
      var cls = filter === 'all'
        ? (d.max >= 5 ? 'hot3' : d.max >= 4 ? 'hot2' : 'hot1')
        : (filter === '5' ? 'hot3' : filter === '4' ? 'hot2' : 'hot1');
      path.classList.add(cls);
      var t = path.querySelector('title');
      if (t) t.textContent = st + ' — ' + d.names.join(', ');
      var txt = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      txt.setAttribute('class', 'hm-label');
      txt.setAttribute('x', path.dataset.cx);
      txt.setAttribute('y', path.dataset.cy);
      txt.textContent = d.count;
      labels.appendChild(txt);
    });
  }

  var bar = document.getElementById('heat-filter');
  if (bar) {
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-star]');
      if (!btn) return;
      bar.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      paint(btn.dataset.star);
    });
  }

  paint('all');
})();
